module.exports = __webpack_public_path__ + "static/img/core-sim-pc-bg.052279e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/core-sim-pc-bg.png
// module id = ygJp
// module chunks = 0